import type { IconSvgObject } from './types';

const Ramadhan01Icon: IconSvgObject = [
  ["path", { d: "M2 12.3049C2 17.6594 6.34065 22 11.6951 22C16.101 22 19.8204 19.0611 21 15.0367C19.5791 16.0691 17.8306 16.6779 15.94 16.6779C11.1804 16.6779 7.32208 12.8196 7.32208 8.06005C7.32208 6.16937 7.93094 4.4209 8.96326 3C4.9389 4.17959 2 7.89904 2 12.3049Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14.6071 10L17.5 8.51852L20.3929 10L19.75 7.03704L22 4.96296L18.8603 4.71854L17.5 2L16.1397 4.71854L13 4.96296L15.25 7.03704L14.6071 10Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.55", key: "1" }]
];

export default Ramadhan01Icon;
